import { ReactNode } from 'react';

export const ListItem = ({
  logo,
  leftSide,
  ArrowIcon,
  rightSide,
}: {
  logo?: ReactNode;
  rightSide: ReactNode;
  leftSide: ReactNode;
  ArrowIcon: ReactNode;
}) => {
  return (
    <div className='flex flex-row justify-between w-full px-2 items-center pointer-events-none'>
      <div className='flex flex-row gap-x-2 justify-center items-center pr-1'>
        {logo}
        {rightSide}
      </div>
      <div className='flex flex-row justify-center items-center'>
        {leftSide} {ArrowIcon}
      </div>
    </div>
  );
};
